import React, { Component } from "react";
import "../css/dataTables.css";
import moment from "moment";
import $ from "jquery";
import PersonContactModal from "./PersonContactModal";
import PartnerCreateModal from "./PartnerCreateModal";
import AlmacenModal from "./AlmacenModal";
import MonedaModal from "./MonedaModal";
import CentroCosteModal from "./CentroCosteModal";
import InvoicesPaymentModal from "./InvoicesPaymentModal";
import CheckListModal from "./CheckListModal";
import AddressesModal from "./AddressesModal";
import SeriesCreateModal from "./SeriesCreateModal";
import SeriesCreateModale from "./SeriesCreateModale";
import EmployeeSalesModal from "./EmployeeSalesModal";
import PropietarioCreateModal from "./PropietarioCreateModal";
import PriceListModal from "./PriceListModal";
import CfdiCreateModal from "./CfdiCreateModal";
import ImpuestoCreateModal from "./ImpuestoCreateModal";
import AccountListModal from "./AccountListModal";
import { ApiClient } from "../libs/apiClient";
import UserFieldsModal from "./UserFieldsModal";
import SelectOfModal from "./SelectOfModal";
import UsersModal from "./UsersModal";
import BranchesModal from "./BranchesModal";
import DepartmentsModal from "./DepartmentsModal";
import ConfirmModal from "./confirmModal";
import CreditLimitModal from "./CreditLimitModal";
import SeriesPagoModal from "./SeriesPagoModal";
import AsientoContableModal from "./AsientoContableModal";
import AccountBalance from "./AccountBalance";
import ProjectsModal from "./ProjectsModal"
import TransactionsModal from "./TransactionsModal"
import PaymentListModaL from "./PaymentListModaL"
import ItemsCreateModal from "./ItemsCreateModal";
import GrossProfitModal from "./GrossProfitModal";
import AddressModal from "./AddressModal"
import SendMailModal from "./SendMailModal"
import ValidationBatchsModal from "./ValidationBatchsModal";
import BatchReportModal from "./BatchReportModal";
import CancelDocuments from "./CancelDocuments";
import CancelCFDI from "./CancelCFDI";
import { NewItem, NewItemPayment, NewItemCheck, UserFields, UserFieldsItem, Permissions, NewService, CreditCards } from "./NewOrder";
import { json, CURRENCY, FORMAT_NUMBER } from "../libs/utils/Const";
import config from "../config";
import download from "js-file-download";
import CardsListModal from "./CardsListModal";
import { ListPartnerModal, ToolTip } from "../components";
import DataXML from "./DataXML";
import Select from "react-select";
import OrderRecommendation from "./OrderRecommendation";
import ConfirmCancelModal from "./confirmCancelModal";
import { ContentLandedCosts } from "../components";
import { GROSSPROFIT } from "../libs/utils/Const";
import Tooltip from "./ToolTip";
let apiClient = ApiClient.getInstance();

const formatNumber = {
    separador: ",", // separador para los miles
    sepDecimal: ".", // separador para los decimales
    formatear: function (num) {
        num += "";
        let splitStr = num.split(".");
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : "";
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol, decimals = 2) {
        this.simbol = simbol || "";
        if (typeof num == "undefined") {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(decimals));
    },
};

const round = (num) => {
    let m = Number((Math.abs(num) * 100).toPrecision(15));
    return Math.round(m) / 100 * Math.sign(num);
}

const customSelectStyles = (action, editMode) => ({
    container: (base) => ({
        ...base,
        flex: 1,
        minWidth: 0
    }),
    control: (base, state) => ({
        ...base,
        height: 40,
        minHeight: 40,
        borderRadius: "0 4px 4px 0",
        borderColor: "#ced4da",
        backgroundColor: action === 2 && !editMode ? "#e9ecef" : "#fff",
        boxShadow: "none",
        cursor: state.isDisabled ? "default" : "pointer",
        "&:hover": {
            borderColor: "#ced4da"
        }
    }),
    valueContainer: (base) => ({
        ...base,
        height: 40,
        padding: "0 12px"
    }),
    placeholder: (base) => ({
        ...base,
        color: "#6c757d"
    }),
    singleValue: (base) => ({
        ...base,
        color: "#495057",
        fontSize: "14px"
    }),
    input: (base) => ({
        ...base,
        color: "#495057",
        margin: 0,
        padding: 0
    }),
    indicatorsContainer: (base) => ({
        ...base,
        height: 40
    }),
    indicatorSeparator: () => ({
        display: "none"
    }),
    dropdownIndicator: (base) => ({
        ...base,
        color: "#8c959f",
        padding: "0 10px",
        "&:hover": {
            color: "#6c757d"
        }
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 9999
    }),
    menu: (base) => ({
        ...base,
        borderRadius: 4,
        overflow: "hidden"
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? "#f1f3f5" : "#fff",
        color: "#212529",
        cursor: "pointer",
        ":active": {
            backgroundColor: "#e9ecef"
        }
    })
});
class NewPriceListModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            partners: [],
            filters: {
                PriceList: "",
                ItemGroup: "",
                FirmCode: "",
            },
            itemsArray: [],
            itemsArrayAux: [],
        };
    }

    componentDidMount = async () => {

    }

    closeModalCreate = async () => {
        const { action, editMode, CloseDocumentModal } = this.props;

        if (action === 1 || editMode) {
            $("#confirmModal").modal("show");
        } else {
            $("#NewPriceListModal").modal("hide");
            await CloseDocumentModal();
        }

        this.setState({
            service: "I",
        });

    }

    renderEditButton = () => {
        const { action, editMode } = this.props;

        if (action === 2 && !editMode) {
            return (
                <button
                    type="button"
                    style={{ backgroundColor: "transparent", color: "#000" }}
                    className="btn btn-editar"
                    onClick={this.editMode}>
                    <i className="fas fa-edit  fa-lg" />
                    Editar
                </button>
            );
        }
    }

    sendModel = () => {
        const { priceListsModel, SendNewPriceList, showAlert } = this.props;
        if (priceListsModel.ListName === "") {
            showAlert({ type: "error", message: "El campo nombre de la lista de precios no puede ir vacío." }, 5000);
            return;
        }

        if (priceListsModel.BASE_NUM === "" || priceListsModel.BASE_NUM === null) {
            showAlert({ type: "error", message: "El campo Lista de precios base por defecto no puede ir vacío." }, 5000);
            return;
        }
        SendNewPriceList(priceListsModel);
    }

    refreshModel = priceListsModel => {
        const { refreshModel } = this.props;
        refreshModel(priceListsModel);
    }

    change_ListName = async (event) => {
        const { priceListsModel } = this.props;
        // this.clearSocio(event.nativeEvent.target.name);
        if (event.nativeEvent.data !== "") {
            priceListsModel.ListName = event.nativeEvent.target.value;
        }
        this.refreshModel(priceListsModel);
    }

    validateListName = async () => {
        const { priceListsModel, AddnewArrayLists, showAlert } = this.props;
        if (priceListsModel.ListName === "") {
            showAlert({ type: "error", message: "El campo nombre de la lista de precios no puede ir vacío." }, 5000);
            return;
        }
        AddnewArrayLists();
    }

    change_BASE_NUM = async (selected) => {
        const { enableSpinner, showAlert, priceListsModel } = this.props;
        let { itemsArray, itemsArrayAux } = this.state;

            priceListsModel.BASE_NUM = selected ? selected.value : "";

        if (itemsArray?.length) {
            if (Number(priceListsModel.BASE_NUM) < 0) {
                for (let i = 0; i < itemsArray.length; i++) {
                    let item = itemsArray[i];
                    let itemAux = itemsArrayAux[i];
                    const price = Number((Number(priceListsModel.BASE_NUM) === -2 ? item.LstEvlPric : item.LastPurPrc) || 0);

                    item.BasePrice = price;
                    if (item.Ovrwritten === "N") {
                        item.Price = (price * Number(item.Factor)).toFixed(4);
                        item.PriceView = formatNumber.new(item.Price, "", 4);
                    }
                    item.BasePLNum = priceListsModel.BASE_NUM;

                    itemAux.BasePrice = price;
                    itemAux.Price = (price * Number(itemAux.Factor)).toFixed(4);
                    itemAux.PriceView = formatNumber.new(itemAux.Price, "", 4);
                    itemAux.BasePLNum = priceListsModel.BASE_NUM;
                }
            } else {
                let { lastFilters } = this.state;

                lastFilters.PriceList = priceListsModel.BASE_NUM;

                enableSpinner(true);
                const response = await apiClient.SearchItemsPL(lastFilters);
                enableSpinner(false);

                if (!response?.data?.length) {
                    return showAlert({ type: "info", message: "No hay información correspondiente a la búsqueda" });
                }

                for (let i = 0; i < itemsArray.length; i++) {
                    let item = itemsArray[i];
                    let itemAux = itemsArrayAux[i];
                    const newItem = response.data.find(({ ItemCode }) => ItemCode === item.ItemCode);
                    const price = newItem?.Price || 0;

                    item.BasePrice = price;
                    if (item.Ovrwritten === "N") {
                        item.Price = (price * Number(item.Factor)).toFixed(4);
                        item.PriceView = formatNumber.new(item.Price, "", 4);
                    }
                    item.BasePLNum = priceListsModel.BASE_NUM;

                    itemAux.BasePrice = price;
                    itemAux.Price = (price * Number(itemAux.Factor)).toFixed(4);
                    itemAux.PriceView = formatNumber.new(itemAux.Price, "", 4);
                    itemAux.BasePLNum = priceListsModel.BASE_NUM;
                }
            }

            await this.setState({ itemsArray, itemsArrayAux });
        }
        this.refreshModel(priceListsModel);
    }

    change_Factor = async (event) => {
        const { priceListsModel } = this.props;
        let value = (event.nativeEvent.target.value).replace(/\-/g, "");
        let valueAux = (event.nativeEvent.target.value).replace(/\,/g, "");
        if (valueAux === ".") valueAux = "0.";

        if (!isNaN(valueAux)) {
            priceListsModel.FactorView = value;
            this.refreshModel(priceListsModel);
        }
    }

    onBlur_Factor = async (value) => {
        const { priceListsModel } = this.props;
        let { itemsArray, itemsArrayAux } = this.state;

        let valueAux = (value).replace(/\,/g, "");
        if (valueAux === ".") valueAux = "0.";

        if (isNaN(valueAux) || (Number(valueAux || 0) <= 0.00004)) {
            value = 1;
        }

        priceListsModel.Factor = Number(Number(value).toFixed(4));
        priceListsModel.FactorView = formatNumber.new(Number(value), "", 4);

        if (itemsArray?.length) {
            for (let i = 0; i < itemsArray.length; i++) {
                let item = itemsArray[i];
                let itemAux = itemsArrayAux[i];
                const price = item.BasePrice;
                const priceAux = itemAux.BasePrice;

                item.Factor = priceListsModel.Factor;

                if (item.Ovrwritten === "N") {
                    item.Price = (price * Number(item.Factor)).toFixed(4);
                    item.PriceView = formatNumber.new(item.Price, "", 4);
                }
                item.FactorView = formatNumber.new(item.Factor, "", 4);

                itemAux.Factor = priceListsModel.Factor;
                itemAux.Price = (priceAux * Number(itemAux.Factor)).toFixed(4);
                itemAux.PriceView = formatNumber.new(itemAux.Price, "", 4);
                itemAux.FactorView = formatNumber.new(itemAux.Factor, "", 4);
            }
        }
        this.refreshModel(priceListsModel);
    }

    change_RoundSys = async (selected) => {
        const { priceListsModel } = this.props;

            priceListsModel.RoundSys = selected ? selected.value : "";
        if (priceListsModel.RoundSys === "0") {
            priceListsModel.RoundRule = "R";
        }
        this.refreshModel(priceListsModel);
    }

    change_RoundRule = async (event) => {
        const { priceListsModel } = this.props;

        if (event.nativeEvent.data !== "") {
            priceListsModel.RoundRule = event.nativeEvent.target.value;
        }
        this.refreshModel(priceListsModel);
    }

    change_GroupCode = async (selected) => {
        const { priceListsModel } = this.props;

            priceListsModel.GroupCode = selected ? selected.value : "";
        this.refreshModel(priceListsModel);
    }

    change_ValidFor = async (event) => {
        const { priceListsModel } = this.props;
        priceListsModel.ValidFor = event.target.checked ? "Y" : "N";
        this.refreshModel(priceListsModel);
    }

    change_PrimCurr = async (selected) => {
        const { priceListsModel } = this.props;

            priceListsModel.PrimCurr = selected ? selected.value : "";
        this.refreshModel(priceListsModel);
    }

    sendModelEdit = () => {
        const { priceListsModel, UpdatePriceList, showAlert } = this.props;
        const { recoverModel, itemsArray, itemsArrayAux } = this.state;
        if (priceListsModel.ListName === "") {
            showAlert({ type: "error", message: "El campo nombre de la lista de precios no puede ir vacío." }, 5000);
            return;
        }

        if (priceListsModel.BASE_NUM === "" || priceListsModel.BASE_NUM === null) {
            showAlert({ type: "error", message: "El campo Lista de precios base por defecto no puede ir vacío." }, 5000);
            return;
        }

        if (itemsArray.length) {
            priceListsModel.Items = [];
            for (let i = 0; i < itemsArray.length; i++) {
                const item = itemsArray[i], itemAux = itemsArrayAux[i];
                if (Number(item.BasePLNum) !== Number(itemAux.BasePLNum)) { priceListsModel.Items.push(item); continue; }
                if (Number(item.Factor) !== Number(itemAux.Factor)) { priceListsModel.Items.push(item); continue; }
                if (Number(item.Price) !== Number(itemAux.Price)) { priceListsModel.Items.push(item); continue; }
                if (item.Ovrwritten !== itemAux.Ovrwritten) { priceListsModel.Items.push(item); continue; }
            }
        }

        let onlyItems = !!priceListsModel?.Items?.length;

        if (onlyItems) {
            for (const prop in priceListsModel) {
                if (priceListsModel[prop] !== recoverModel[prop] && prop !== "Items") {
                    onlyItems = false;
                    break;
                }
            }
        }

        UpdatePriceList(priceListsModel, onlyItems);
    }

    editMode = async () => {
        const { priceListsModel, changeEditModePriceList } = this.props;
        const recoverModel = JSON.parse(JSON.stringify(priceListsModel));
        await this.setState({ recoverModel });
        changeEditModePriceList();
    }

    cancelAction = async () => {
        const { action, changeEditModePriceList } = this.props;
        const { recoverModel } = this.state;

        if (action === 1) {
            $("#confirmModal").modal("show");
        } else {
            await this.refreshModel(recoverModel);
            await this.setState({
                recoverModel: null,
                filters: {
                    PriceList: "",
                    ItemGroup: "",
                    FirmCode: "",
                },
                itemsArray: [],
                itemsArrayAux: [],
            });
            changeEditModePriceList();
        }
    }

    changeFilter = (field, value) => {
        let { filters } = this.state;
        filters[field] = value;
        this.setState({ filters });
    }

    searchItems = async () => {
        const { priceListsModel, enableSpinner, showAlert } = this.props;
        let { filters, recoverModel } = this.state;

        if (!filters.ItemGroup && !filters.FirmCode) {
            return showAlert({ type: "warning", message: "Selecciona algun filtro de búsqueda" });
        }

        filters.PriceList = priceListsModel.ListNum;
        filters.BasePLNum = (Number(priceListsModel.BASE_NUM) !== Number(recoverModel.BASE_NUM)) ? priceListsModel.BASE_NUM : null;

        enableSpinner(true);
        const response = await apiClient.SearchItemsPL(filters);
        enableSpinner(false);

        if (!response?.data?.length) {
            await this.setState({
                itemsArray: [],
                itemsArrayAux: [],
            });
            return showAlert({ type: "info", message: "No hay información para mostrar" });
        }

        if ((Number(priceListsModel.Factor) !== Number(recoverModel.Factor)) || (Number(priceListsModel.BASE_NUM) !== Number(recoverModel.BASE_NUM))) {
            for (let item of response.data) {
                const price = item.BasePrice;

                item.BasePLNum = (Number(priceListsModel.BASE_NUM) !== Number(recoverModel.BASE_NUM)) ? priceListsModel.BASE_NUM : item.BasePLNum;
                item.Factor = (Number(priceListsModel.Factor) !== Number(recoverModel.Factor)) ? priceListsModel.Factor : item.Factor;
                if (item.Ovrwritten === "N") {
                    item.Price = (price * Number(item.Factor)).toFixed(4);
                    item.PriceView = formatNumber.new(item.Price, "", 4);
                }
                item.FactorView = formatNumber.new(item.Factor, "", 4);
            }
        }

        await this.setState({
            itemsArray: JSON.parse(JSON.stringify(response.data)),
            itemsArrayAux: JSON.parse(JSON.stringify(response.data)),
            lastFilters: JSON.parse(JSON.stringify(filters)),
        });
    }

    editGlobalItemValue = async (field, value) => {
        const { enableSpinner, showAlert, priceListsModel } = this.props;
        let { itemsArray } = this.state;

        if (field === "BasePLNum") {
            if (Number(value) < 0) {
                for (let item of itemsArray) {
                    const price = Number((Number(value) === -2 ? (item.LstEvlPric) : (item.LastPurPrc)) || 0);

                    item.BasePrice = price;
                    if (item.Ovrwritten === "N") {
                        item.Price = (price * Number(item.Factor)).toFixed(4);
                        item.PriceView = formatNumber.new(item.Price, "", 4);
                    }
                    item.BasePLNum = value;
                }
            } else {
                let { lastFilters } = this.state;

                lastFilters.PriceList = value;

                enableSpinner(true);
                const response = await apiClient.SearchItemsPL(lastFilters);
                enableSpinner(false);

                if (!response?.data?.length) {
                    return showAlert({ type: "info", message: "No hay información correspondiente a la búsqueda" });
                }

                for (let item of itemsArray) {
                    const newItem = response.data.find(({ ItemCode }) => ItemCode === item.ItemCode);
                    const price = newItem?.Price || 0;

                    item.BasePrice = price;                    
                    if (item.Ovrwritten === "N") {
                        item.Price = (price * Number(item.Factor)).toFixed(4);
                        item.PriceView = formatNumber.new(item.Price, "", 4);
                    }
                    item.BasePLNum = value;
                }
            }
            await this.setState({ itemsArray });
        }
        else if (field === "Factor") {
            value = value.replace(/\-/g, "");
            let auxValue = value.replace(/\,/g, "");
            if (isNaN(auxValue)) return;
            this.setState({ globalFactor: value.trim() });
        }
    }

    editItemValue = async (index, field, value, type = "text") => {
        const { enableSpinner, showAlert } = this.props;
        let { itemsArray } = this.state;
        if (type === "number") {
            value = value.replace(/\-/g, "");
            let valueAux = value.replace(/\,/g, "");
            if (valueAux === ".") valueAux = "0.";
            if (isNaN(valueAux)) return;

            value = value.trim();
        }
        else if (field === "BasePLNum") {
            let price = 0;
            if (Number(value) === -2) {
                price = Number(itemsArray[index].LstEvlPric || 0);
            }
            else if (Number(value) === -1) {
                price = Number(itemsArray[index].LastPurPrc || 0);
            }
            else {
                enableSpinner(true);
                const response = await apiClient.SearchItemsPL({ ItemCode: itemsArray[index].ItemCode, PriceList: value});
                enableSpinner(false);
                
                if (!response?.data?.length) return showAlert({ type: "warning", message: "Ocurrió un error inesperado" });
                price = Number(response.data[0].Price || 0);
            }

            itemsArray[index].BasePrice = price;
            itemsArray[index].Price = (price * Number(itemsArray[index].Factor)).toFixed(4);
        }
        else if (field === "Ovrwritten" && value === "N") {
            itemsArray[index].Price = Number((itemsArray[index].BasePrice * Number(itemsArray[index].Factor)).toFixed(4));
            itemsArray[index].PriceView = formatNumber.new(Number(itemsArray[index].Price), "", 4);
        }

        itemsArray[index][field] = value;
        this.setState({ itemsArray });
    }

    onBlurItem = async (index, field, value, field2) => {
        let { itemsArray } = this.state;
        if (!value) value = "0";

        let valueAux = value.replace(/\,/g, "");
        if (valueAux === ".") valueAux = "0.";
        if (isNaN(valueAux) || Number(valueAux) <= 0.00004) valueAux = field === "Factor" ? 1 : 0;
        itemsArray[index][field] = Number(valueAux);

        if (field === "Factor" && itemsArray[index].Ovrwritten === "N") {
            itemsArray[index].Price = Number((itemsArray[index].BasePrice * Number(valueAux)).toFixed(4));
            itemsArray[index].PriceView = formatNumber.new(Number(itemsArray[index].Price), "", 4);
        }
        else if (field === "Price" && Number(valueAux).toFixed(4) !== (itemsArray[index].BasePrice * Number(itemsArray[index].Factor)).toFixed(4)) {
            itemsArray[index].Ovrwritten = "Y";
        }

        if (field2) {
            itemsArray[index][field2] = formatNumber.new(Number(valueAux), "", 4);
        }

        this.setState({ itemsArray });
    }

    render() {
        const { action, CloseDocumentModal, priceListsModel, newArrayLists, editMode, itemGroupArray, firmArray } = this.props;
        const { filters, itemsArray, editPLBase, editFactor } = this.state;
        const lineStyle = { maxWidth: 300, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" };

        return (
            <div className="modal fade bd-example-modal-md modal-open scroll"
                id="NewPriceListModal"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                style={{ zIndex: 90 }}>

                <ConfirmModal
                    CloseDocumentModal={CloseDocumentModal} />

                <div className="modal-dialog modal-xl modal-open modalOrder" role="document">
                    <div className="modal-content" id="printThis">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: "#343a40", borderRadius: "0" }}>
                            <h4 className="modal-title" id="modal-basic-title ">
                                {action === 2 ? "Detalle de " : "Nueva "}Lista de Precios
                            </h4>
                            <button type="button" className="close" onClick={this.closeModalCreate} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>

                        <div className="modal-body" >
                            {this.renderEditButton()}
                            <div className="row justify-content-around">
                                {/* Primer columna */}
                                <div className="col-12 col-md-6">
                                    {/* No del cliente */}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre de la lista de precios</span>
                                        </div>
                                        <input type="text" className="form-control" id="txtPartner" autocomplete="on"
                                            // style={{ backgroundColor: priceListsModel.partnerSelected ? "rgb(248,242,209)" : "transparent", }}
                                            disabled={action === 2}
                                            onKeyDown={(ev) => {
                                                if (ev.key === "Tab") {
                                                    this.validateListName();
                                                }
                                            }}
                                            onBlur={() => this.validateListName()}
                                            onChange={this.change_ListName}
                                            value={priceListsModel.ListName ? priceListsModel.ListName : ""} />
                                    </div>
                                    {/* Factores */}
                                    {/* <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Factores</span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="txtName"
                                            disabled="true"
                                            value={priceListsModel.variable ? priceListsModel.variable : ""}
                                        />
                                    </div> */}
                                    {/* Lista de precios base por defecto */}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Lista de precios base por defecto</span>
                                        </div>
                                        <Select
                                            className="p-0 border-0"
                                            classNamePrefix="react-select"
                                            id="selectBASE_NUM"
                                            isSearchable={true}
                                            isClearable={false}
                                            isDisabled={action === 2 && !editMode}
                                            options={[
                                                { value: "", label: "" },
                                                { value: -2, label: "Último precio determinado" },
                                                { value: -1, label: "Último precio de compra" },
                                                ...(newArrayLists || []).map(list => ({
                                                    value: list.ListNum,
                                                    label: list.ListName
                                                }))
                                            ]}
                                            value={[
                                                { value: "", label: "" },
                                                { value: -2, label: "Último precio determinado" },
                                                { value: -1, label: "Último precio de compra" },
                                                ...(newArrayLists || []).map(list => ({
                                                    value: list.ListNum,
                                                    label: list.ListName
                                                }))
                                            ].find(opt => String(opt.value) === String(priceListsModel.BASE_NUM)) || null}
                                            onChange={(selected) => this.change_BASE_NUM(selected)}
                                            placeholder="Seleccionar"
                                            noOptionsMessage={() => "Sin opciones"}
                                            menuPortalTarget={document.body}
                                            styles={customSelectStyles(action, editMode)}
                                        />
                                    </div>
                                    {/* Factor por defecto */}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Factor por defecto</span>
                                        </div>
                                        <input
                                            className="form-control text-right"
                                            disabled={action === 2 && !editMode}
                                            onChange={(event) => this.change_Factor(event)}
                                            onBlur={() => this.onBlur_Factor(priceListsModel.FactorView || "")}
                                            value={priceListsModel.FactorView || ""}
                                        />
                                    </div>
                                    {/* Método de redondeo */}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Método de redondeo</span>
                                        </div>
                                        <Select
                                            className="p-0 border-0"
                                            classNamePrefix="react-select"
                                            id="selectRoundSys"
                                            isSearchable={true}
                                            isClearable={false}
                                            isDisabled={action === 2 && !editMode}
                                            options={[
                                                { value: "0", label: "Sin redondeo" },
                                                { value: "1", label: "Redondear a importe en decimales entero" },
                                                { value: "2", label: "Redondear a importe entero" },
                                                { value: "3", label: "Redondear a decenas enteras" },
                                                { value: "4", label: "Final fijo" },
                                                { value: "5", label: "Intervalo fijo" }
                                            ]}
                                            value={[
                                                { value: "0", label: "Sin redondeo" },
                                                { value: "1", label: "Redondear a importe en decimales entero" },
                                                { value: "2", label: "Redondear a importe entero" },
                                                { value: "3", label: "Redondear a decenas enteras" },
                                                { value: "4", label: "Final fijo" },
                                                { value: "5", label: "Intervalo fijo" }
                                            ].find(opt => String(opt.value) === String(priceListsModel.RoundSys)) || null}
                                            onChange={(selected) => this.change_RoundSys(selected)}
                                            placeholder="Seleccionar"
                                            noOptionsMessage={() => "Sin opciones"}
                                            menuPortalTarget={document.body}
                                            styles={customSelectStyles(action, editMode)}
                                        />
                                    </div>
                                    {/* Regla redondeo */}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Regla redondeo</span>
                                        </div>
                                        <select name="select" className="form-control" id="selectRoundRule"
                                            style={{ color: "#000", borderRadius: 4, backgroundColor: priceListsModel.RoundSys === "0" ? "#e9ecef" : "transparent", height: 40 }}
                                            value={priceListsModel.RoundRule}
                                            disabled={(priceListsModel.RoundSys === "0" || (action === 2 && !editMode))}
                                            onChange={(event) => this.change_RoundRule(event)}
                                        >
                                            <option key={"RoundRule-R"} value="R">Redondear al más cercano</option>
                                            <option key={"RoundRule-C"} value="C">Redondear por exceso</option>
                                            <option key={"RoundRule-F"} value="F">Redondear por defecto</option>
                                        </select>
                                    </div>
                                    {/* Final/Intervalo */}
                                    {/* <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Final/Intervalo</span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="txtLocalCurrency"
                                            disabled={true}
                                            value={priceListsModel.variable ? priceListsModel.variable : 1}
                                        />
                                    </div> */}
                                </div>

                                {/* Segunda columna */}
                                <div className="col-12 col-md-6">
                                    {/* Grupo de autorización */}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Grupo de autorización</span>
                                        </div>
                                        <Select
                                            className="p-0 border-0"
                                            classNamePrefix="react-select"
                                            id="selectGroupCode"
                                            isSearchable={true}
                                            isClearable={false}
                                            isDisabled={action === 2 && !editMode}
                                            options={[
                                                { value: "1", label: "Grupo 1" },
                                                { value: "2", label: "Grupo 2" },
                                                { value: "3", label: "Grupo 3" },
                                                { value: "4", label: "Grupo 4" }
                                            ]}
                                            value={[
                                                { value: "1", label: "Grupo 1" },
                                                { value: "2", label: "Grupo 2" },
                                                { value: "3", label: "Grupo 3" },
                                                { value: "4", label: "Grupo 4" }
                                            ].find(opt => String(opt.value) === String(priceListsModel.GroupCode)) || null}
                                            onChange={(selected) => this.change_GroupCode(selected)}
                                            placeholder="Seleccionar"
                                            noOptionsMessage={() => "Sin opciones"}
                                            menuPortalTarget={document.body}
                                            styles={customSelectStyles(action, editMode)}
                                        />
                                    </div>
                                    {/* Precio bruto */}
                                    {/* <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Precio bruto</span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="txtCustomerRefNo"
                                            disabled={action === 2 && !editMode}
                                            value={priceListsModel.IsGrossPrc ? priceListsModel.IsGrossPrc : ""}
                                            onChange={this.changeNoReferencia}
                                            disabled={action === 2 && !editMode}
                                            style={{ backgroundColor: "transparent", borderColor: "#ced4da", color: "#000" }}
                                        />
                                    </div> */}
                                    {/* Activo */}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" style={{height: "40px", width: "52px", padding: 0, display: "flex", alignItems: "center", justifyContent: "center"}}>
                                                <input
                                                    type="checkbox"
                                                    className="form-control"
                                                    id="chkValidFor"
                                                    disabled={action === 2 && !editMode}
                                                    checked={priceListsModel.ValidFor === "Y"}
                                                    onChange={(event) => this.change_ValidFor(event)}
                                                    style={{ width: "24px", height: "24px", margin: 0, padding: 0 }}/>
                                            </span>
                                        </div>
                                        <label className="form-control disabled" htmlFor="chkValidFor" style={{ height: "40px", display: "flex", alignItems: "center", marginBottom: 0 }}> Activo </label>
                                    </div>
                                    {/* Moneda primaria */}
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Moneda primaria</span>
                                        </div>
                                        <Select
                                            className="p-0 border-0"
                                            classNamePrefix="react-select"
                                            id="selectPrimCurr"
                                            isSearchable={true}
                                            isClearable={false}
                                            isDisabled={action === 2 && !editMode}
                                            options={[
                                                { value: "CAN", label: "Canadian Dollar" },
                                                { value: "EUR", label: "Euro" },
                                                { value: "MXP", label: "Peso Mexicano" },
                                                { value: "USD", label: "US Dolar" }
                                            ]}
                                            value={[
                                                { value: "CAN", label: "Canadian Dollar" },
                                                { value: "EUR", label: "Euro" },
                                                { value: "MXP", label: "Peso Mexicano" },
                                                { value: "USD", label: "US Dolar" }
                                            ].find(opt => opt.value === priceListsModel.PrimCurr) || null}
                                            onChange={(selected) => this.change_PrimCurr(selected)}
                                            placeholder="Seleccionar"
                                            noOptionsMessage={() => "Sin opciones"}
                                            menuPortalTarget={document.body}
                                            styles={customSelectStyles(action, editMode)}
                                        />
                                    </div>
                                    {/* SOLO PARA SERDI */}
                                    {/* Plaza */}
                                    {/* <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Plaza</span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="txtCustomerRefNo"
                                            disabled={action === 2 && !editMode}
                                            value={priceListsModel.U_Plaza ? priceListsModel.U_Plaza : ""}
                                            onChange={this.changeNoReferencia}
                                            style={{ backgroundColor: "transparent", borderColor: "#ced4da", color: "#000" }}
                                        />
                                    </div> */}
                                    {/* Tipo */}
                                    {/* <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Tipo</span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="txtCustomerRefNo"
                                            disabled={action === 2 && !editMode}
                                            value={priceListsModel.U_Tipo ? priceListsModel.U_Tipo : ""}
                                            onChange={this.changeNoReferencia}
                                            style={{ backgroundColor: "transparent", borderColor: "#ced4da", color: "#000" }}
                                        />
                                    </div> */}
                                </div>
                            </div>
                            {action === 2 && editMode &&
                                <div className="p-3 border rounded">
                                    <div className="row">
                                        <div className="col-12 col-md-6 col-lg-4">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold"> Grupo </span>
                                                </div>
                                                <select
                                                    className="form-control"
                                                    value={filters?.ItemGroup || ""}
                                                    onChange={({ target: { value }}) => this.changeFilter("ItemGroup", value)} >
                                                    <option value=""> Seleccionar </option>
                                                    {Array.isArray(itemGroupArray) ? itemGroupArray.map(option => <option key={`itemGroup${option.ItmsGrpCod}`} value={option.ItmsGrpCod}> {option.ItmsGrpNam} </option>) : ""}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-4">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold"> Fabricante </span>
                                                </div>
                                                <select
                                                    className="form-control"
                                                    value={filters?.FirmCode || ""}
                                                    onChange={({ target: { value }}) => this.changeFilter("FirmCode", value)} >
                                                    <option value=""> Seleccionar </option>
                                                    {Array.isArray(firmArray) ? firmArray.map(option => <option key={`firmCode${option.FirmCode}`} value={option.FirmCode}> {option.FirmName} </option>) : ""}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-4">
                                            <button type="button" className="btn btn-outline-dark" onClick={this.searchItems}> <i className="fas fa-search mr-2"/> Buscar </button>
                                        </div>
                                        <div className="col-12" style={{ overflow: "auto", maxHeight: 300 }}>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th className="table-header-yellow text-center p-2" style={lineStyle}> # </th>
                                                        <th className="table-header-yellow text-center p-2" style={lineStyle}> Artículo </th>
                                                        <th className="table-header-yellow text-center p-2" style={lineStyle}> Descripción </th>
                                                        {!itemsArray.length ? <th className="table-header-yellow text-center p-2" style={lineStyle}> Lista Base </th> :
                                                            (!editPLBase ?
                                                                <th
                                                                    className="table-header-yellow text-center p-2"
                                                                    style={{ ...lineStyle, cursor: "pointer" }}
                                                                    onClick={async () => {
                                                                        await this.setState({ editPLBase: !editPLBase });
                                                                        const globalPLSelect = document.getElementById("globalPLSelect");
                                                                        globalPLSelect.focus();
                                                                    }} >  Lista Base <i className="fas fa-edit ml-2"/>
                                                                </th> :
                                                                <th className="table-header-yellow text-center p-2" style={{ ...lineStyle, cursor: "pointer" }}>
                                                                    <select
                                                                        id="globalPLSelect"
                                                                        className="form-control"
                                                                        style={{ width: 250 }}
                                                                        onChange={({ target: { value } }) => this.editGlobalItemValue("BasePLNum", value)}
                                                                        onBlur={() => this.setState({ editPLBase: false })} >

                                                                        <option value={-2}>Último precio determinado</option>
                                                                        <option value={-1}>Último precio de compra</option>
                                                                        {!!newArrayLists && newArrayLists.map(list => <option key={`itemBaseListGlobal-${list.ListNum}`} value={list.ListNum}> {list.ListName} </option>)}
                                                                    </select>
                                                                </th>
                                                            )
                                                        }
                                                        {!itemsArray.length ? <th className="table-header-yellow text-center p-2" style={lineStyle}> Factor </th> :
                                                            (!editFactor ?
                                                                <th
                                                                    className="table-header-yellow text-center p-2"
                                                                    style={{ ...lineStyle, cursor: "pointer" }}
                                                                    onClick={async () => {
                                                                        await this.setState({ globalFactor: "1.0000", editFactor: !editFactor });
                                                                        const globalFactorInput = document.getElementById("globalFactorInput");
                                                                        globalFactorInput.focus();
                                                                    }} >  Factor <i className="fas fa-edit ml-2"/>
                                                                </th> :
                                                                <th className="table-header-yellow text-center p-2" style={{ ...lineStyle, cursor: "pointer" }}>
                                                                    <input
                                                                        id="globalFactorInput"
                                                                        className="form-control text-right"
                                                                        style={{ width: 100 }}
                                                                        value={this.state.globalFactor || ""}
                                                                        onChange={({ target: { value } }) => this.editGlobalItemValue("Factor", value)}
                                                                        onBlur={async ({ target: { value } }) => {
                                                                            let { itemsArray } = this.state;

                                                                            value = value.replace(/\,/g, "");
                                                                            if (isNaN(value) || Number(value) <= 0.00004) { value = 1; }

                                                                            for (let item of itemsArray) {
                                                                                const price = item.BasePrice || 0;

                                                                                item.Factor = Number(value).toFixed(4);
                                                                                if (item.Ovrwritten === "N") {
                                                                                    item.Price = (price * Number(item.Factor)).toFixed(4);
                                                                                    item.PriceView = formatNumber.new(item.Price, "", 4);
                                                                                }
                                                                                item.FactorView = formatNumber.new(item.Factor, "", 4);
                                                                            }
                                                                            await this.setState({ globalFactor: "", editFactor: false, itemsArray });
                                                                        }} />
                                                                </th>
                                                            )
                                                        }
                                                        <th className="table-header-yellow text-center p-2" style={lineStyle}> Precio Base </th>
                                                        <th className="table-header-yellow text-center p-2" style={lineStyle}> Precio Unitario </th>
                                                        <th className="table-header-yellow text-center p-2" style={lineStyle}> Manual </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {itemsArray.length ?
                                                        itemsArray.map((item, index) => 
                                                            <tr key={`itemIndex${index}`}>
                                                                <td className={`p-2 dt-row-${index % 2 === 0 ? "primary" : "secondary"}`} style={lineStyle}> {index + 1} </td>
                                                                <td className={`p-2 dt-row-${index % 2 === 0 ? "primary" : "secondary"}-light`} style={lineStyle}> {item.ItemCode} </td>
                                                                <td className={`p-2 dt-row-${index % 2 === 0 ? "primary" : "secondary"}-light`} style={lineStyle}> {item.ItemName} </td>
                                                                <td className={`p-2 dt-row-${index % 2 === 0 ? "primary" : "secondary"}-light`} style={lineStyle}> 
                                                                    <select
                                                                        className="form-control"
                                                                        style={{ width: 250 }}
                                                                        value={item.BasePLNum || 0}
                                                                        onChange={({ target: { value } }) => this.editItemValue(index, "BasePLNum", value)} >
                                                                        <option value={-2}>Último precio determinado</option>
                                                                        <option value={-1}>Último precio de compra</option>
                                                                        {!!newArrayLists && newArrayLists.map(list => <option key={`itemBaseList${index}-${list.ListNum}`} value={list.ListNum}> {list.ListName} </option>)}
                                                                    </select>
                                                                </td>
                                                                <td className={`p-2 dt-row-${index % 2 === 0 ? "primary" : "secondary"}-light`} style={lineStyle}>
                                                                    <input
                                                                        className="form-control text-right"
                                                                        style={{ width: 100 }}
                                                                        value={item.FactorView || ""}
                                                                        onChange={({ target: { value } }) => this.editItemValue(index, "FactorView", value, "number")}
                                                                        onBlur={() => this.onBlurItem(index, "Factor", item.FactorView, "FactorView")} />
                                                                </td>
                                                                <td className={`p-2 dt-row-${index % 2 === 0 ? "primary" : "secondary"}-light text-right`} style={lineStyle}> {Number(item.BasePrice || 0).toFixed(4)} </td>
                                                                <td className={`p-2 dt-row-${index % 2 === 0 ? "primary" : "secondary"}-light`} style={lineStyle}>
                                                                    <input
                                                                        className="form-control text-right"
                                                                        style={{ width: 100 }}
                                                                        value={item.PriceView || ""}
                                                                        onChange={({ target: { value } }) => this.editItemValue(index, "PriceView", value, "number")}
                                                                        onBlur={() => this.onBlurItem(index, "Price", item.PriceView, "PriceView")}/>
                                                                </td>
                                                                <td className={`p-2 dt-row-${index % 2 === 0 ? "primary" : "secondary"}-light`} style={lineStyle}>
                                                                    <div className="d-flex w-100 justify-content-center">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-control"
                                                                            style={{ width: 20, height: 20 }}
                                                                            checked={item.Ovrwritten === "Y"}
                                                                            disabled={item.PriceList === item.BasePLNum}
                                                                            onChange={() => this.editItemValue(index, "Ovrwritten", (item.Ovrwritten === "Y" ? "N" : "Y"))} />
                                                                    </div>
                                                                </td>
                                                            </tr>) :
                                                        <tr> <td className="p-2 dt-row-primary text-center" colSpan={8}> No hay información </td> </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                        <div className="modal-footer">
                            {(Number(action) === 2 && !editMode) ?
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeModalCreate}> Cerrar </button> :
                                <button type="button" className="btn botonCerrar text-white" onClick={this.cancelAction}> Cancelar </button>
                            }

                            {Number(action) === 1 &&
                                <button type="button" className="btn botonCorrect text-black" onClick={this.sendModel}> Crear </button>
                            }

                            {Number(action) === 2 &&
                                <button type="button" className="btn botonCorrect text-black" onClick={this.sendModelEdit}> Guardar </button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NewPriceListModal;